<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout v-if="!loading" row wrap>
            <v-flex xs12 v-bind:class="[!vertical ? 'lg6': null]" v-if="!hideTable">
                <v-data-table
                        :headers="headers"
                        disable-initial-sort
                        :items="faults"
                        :rows-per-page-items="[7,14,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                >
                    <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.title }}</td>
                        <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                        <td class="text-xs-left">{{ props.item.equipment_type }}</td>
                        <td class="text-xs-left">{{ props.item.floor }}</td>
                        <td class="text-xs-left">{{props.item.start_date}}</td>
                        <td class="text-xs-left">{{props.item.end_date}}</td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                    small
                                    @click="jumpToLink(props.item)"
                            >
                                fa-chart-line
                            </v-icon>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex xs12 v-bind:class="[!vertical&&!hideTable ? 'lg6': null]">
                <v-layout row wrap>
                    <v-flex xs12 lg6>
                        <vue-plotly :white-mode="whiteMode" v-if="faultPieData1" disable-responsive :data="faultPieData1"
                                    :layout="faultPieLayout1" :options="{}" @click="jumpToNotification($event,'severity')"/>
                    </v-flex>
                    <v-flex xs12 lg6>
                        <vue-plotly :white-mode="whiteMode" v-if="faultPieData2" disable-responsive :data="faultPieData2"
                                    :layout="faultPieLayout2" :options="{}" @click="jumpToNotification($event,'topic')"/>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {getNotification} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    export default {
        props: {
            dateRange: {type: Object, default: null},
            vertical: {type: Boolean, default: false},
            hideTable: {type: Boolean, default: false},
            whiteMode: {type: Boolean, default: false},
        },
        components: {LoadingProgressBar,VuePlotly},
        computed: {},
        name: 'FaultBreakdownWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                faults:[],
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                headers: [
                    {
                        text: this.$options.filters.translate('Issue'),
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {text: this.$options.filters.translate('Equipment'), value: 'equipment_name'},
                    {text: this.$options.filters.translate('Equipment Type'), value: 'equipment_type'},
                    {text: this.$options.filters.translate('Floor'), value: 'floor'},
                    {text: this.$options.filters.translate('Start Date'), value: 'start_date'},
                    {text: this.$options.filters.translate('End Date'), value: 'end_date'},
                    {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false}
                ],
                faultPieData1:null,
                faultPieData2:null,
                faultPieLayout1:{
                    title:this.$options.filters.translate("Fault severity"),
                    legend: {
                        orientation: 'h',
                        x: 0.1
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                faultPieLayout2:{
                    title:this.$options.filters.translate("Fault breakdown"),
                    legend: {
                        orientation: 'h',
                        x:0.1
                    },
                    margin:{
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            jumpToNotification(data,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=data.points[0].label
                this.$router.push(output)
            },
            jumpToLink(item) {
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equipment_name
                        }
                    }
                } else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equipment_name
                        }
                    }
                }

                this.$router.push(output)
            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            getData(){
                let me=this
                me.loading=true
                let ahus=[]
                let paus=[]
                let cts=[]
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if (equip.equipment_type === "ECFAN" || equip.equipment_type === "AHU") {
                        ahus.push(equip.equipment_name)
                    } else if (equip.equipment_type === "PAU") {
                        paus.push(equip.equipment_name)
                    } else if (equip.equipment_type === "COOLING_TOWER") {
                        cts.push(equip.equipment_name)
                    }
                }
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:[this.dateRange.start,this.dateRange.end],
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result.filter(x=>x.topic!=="anomaly"&&!x.title.toLowerCase().startsWith("anomaly"))
                    let cpFaultSeverity = { }
                    let cpFaultTopic = { }
                    for (let fault of rangeFaults){
                        if(!cpFaultSeverity[fault.severity]){
                            cpFaultSeverity[fault.severity]=1
                        } else {
                            cpFaultSeverity[fault.severity]=cpFaultSeverity[fault.severity]+1
                        }
                        if(!cpFaultTopic[fault.topic]){
                            cpFaultTopic[fault.topic]=1
                        } else {
                            cpFaultTopic[fault.topic]=cpFaultTopic[fault.topic]+1
                        }
                    }
                    let faultEquip = { }
                    for (let fault of rangeFaults){
                        if(!faultEquip[fault.equipment_type]){
                            faultEquip[fault.equipment_type]=1
                        } else {
                            faultEquip[fault.equipment_type]=faultEquip[fault.equipment_type]+1
                        }
                    }
                    me.faults=rangeFaults.sort((a, b) => (a.start_date < b.start_date) ? 1 : -1);
                    let faultPieData1={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        marker: {
                            colors:[],
                        },
                        values: []
                    }
                    for (let severity in cpFaultSeverity){
                        faultPieData1.labels.push(severity)
                        faultPieData1.marker.colors.push(me.severityColors[severity])
                        faultPieData1.values.push(cpFaultSeverity[severity])
                    }
                    me.faultPieData1=[faultPieData1];
                    let fddRepData=[]
                    rangeFaults=rangeFaults.filter(x=>x.equipment_type)
                    let faultsByType={
                        'Chillers':rangeFaults.filter(x=>x.equipment_type.toLowerCase().startsWith('chiller')),
                        'Pumps':rangeFaults.filter(x=>x.equipment_type.toLowerCase().endsWith('water_pump')),
                        'VAVs':rangeFaults.filter(x=>x.equipment_type==="VAV")
                    }
                    if(ahus.length>0){
                        faultsByType['AHUs']=rangeFaults.filter(x=>x.equipment_type==="ECFAN"||x.equipment_type==="AHU")
                    }
                    if(paus.length>0){
                        faultsByType['PAUs']=rangeFaults.filter(x=>x.equipment_type==="PAU")
                    }
                    if(cts.length>0){
                        faultsByType['Cooling Towers']=rangeFaults.filter(x=>x.equipment_type==="COOLING_TOWER")
                    }
                    for (let faultType in faultsByType){
                        let part={
                            x:[],
                            y:[],
                            name: me.$options.filters.translate(faultType),
                            type: 'bar',
                            orientation: 'h'
                        }
                        for (let topic in cpFaultTopic){
                            part.y.push(topic)
                            part.x.push(faultsByType[faultType].filter(x=>x.topic===topic).length)
                        }
                        fddRepData.push(part)
                    }
                    me.faultPieData2=fddRepData;
                    me.loading=false;
                })

            }
        },
    }
</script>
